// extracted by mini-css-extract-plugin
module.exports = {"container":"ChatBox_container__2G42y","default":"ChatBox_default__3Ogmp"};